export interface SalesContractLineHeader {
  id: string;
  salesContractHeaderId: string;
  contractNo: number;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  description: string;
  quantity: number;
  unitOfMeasure: string;
  price: number;
  contractValue: number;
  contractLineBalance: number;
  contractLineBalanceValue: number;
  canDelete: boolean;
}
